// VB-019 — Tour closing modal: final step of the guided tour
// Visually consistent with OnboardingWelcomeModal
import { CheckCircle2, ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface OnboardingTourClosingModalProps {
  onDone: () => void;
  onPrev: () => void;
}

export function OnboardingTourClosingModal({ onDone, onPrev }: OnboardingTourClosingModalProps) {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
      <div
        className="bg-zinc-900 border border-zinc-800 rounded-2xl w-full max-w-md shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-8">
          {/* Icon */}
          <div className="w-10 h-10 rounded-xl bg-emerald-500/15 text-emerald-400 flex items-center justify-center mb-6">
            <CheckCircle2 className="w-5 h-5" />
          </div>

          <h2 className="text-xl font-semibold text-zinc-100 mb-1.5">
            {t('onboarding.tour_step_ready_title')}
          </h2>
          <p className="text-zinc-400 text-sm mb-8 leading-relaxed">
            {t('onboarding.closing_body')}
          </p>

          {/* CTAs */}
          <div className="flex items-center gap-3">
            <button
              onClick={onPrev}
              className="flex items-center gap-1.5 px-4 py-2.5 rounded-xl border border-zinc-700 text-zinc-400 hover:text-zinc-100 hover:border-zinc-600 text-sm font-medium transition-colors"
            >
              <ChevronLeft className="w-4 h-4" />
              {t('common.back')}
            </button>
            <button
              onClick={onDone}
              className="flex-1 px-4 py-2.5 rounded-xl bg-zinc-100 hover:bg-zinc-200 text-zinc-950 text-sm font-medium transition-colors"
            >
              {t('onboarding.lets_go')} →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
